import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { reflection, background } from './renegades.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/220704/renegades-le_sas/renegades-le_sas_{nnn}.png',
}

export default {
  layers: [background, body, reflection],
  resolveOptions: () => ({
    reflections: 'r5pc',
  }),
}
